// The event flip is the round's payoff. The table holds the card face down
// for a beat before turning it, so a room full of people gets to wonder -
// the house rule since the drama report (2026-08-29): a reveal that flashes
// past isn't fun. Skippable with a tap; zero under reduced motion.

export const EVENT_HOLD_MS = 1600;

export const prefersReducedMotion = () => (
  typeof window !== 'undefined'
  && typeof window.matchMedia === 'function'
  && window.matchMedia('(prefers-reduced-motion: reduce)').matches
);

export const eventHoldMs = () => (prefersReducedMotion() ? 0 : EVENT_HOLD_MS);
